module.exports = __webpack_public_path__ + "img/pic_tab1_notenoughcoins@3x.843a02c2.png";